import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Menu from '../components/Menu';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAllContext } from '../context/AllContext';
import { FaRegCalendarAlt, FaRegTrashAlt } from 'react-icons/fa';
import { BiEditAlt } from 'react-icons/bi';
import axios from 'axios';
import { toast } from 'react-toastify';

const PostDetails = () => {
    const { t, i18n } = useTranslation()
    const params = useParams();
    const navigate = useNavigate();
    const limitsUser = JSON.parse(localStorage.getItem('limitsUser'));
    const { getSingleUserPost, singleUserPost } = useAllContext()

    const deleteUserPost = async (id) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/user-post-delete/${id}`, {
                headers: {
                    Authorization: limitsUser.token
                }
            })
            const data = await response.data

            if (data.status === 1) {
                toast.success(data.message)
                navigate("/my-profile")
            }

        } catch (error) {
            console.log('Error:', error);
        }
    }

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (params && limitsUser) {
            getSingleUserPost(limitsUser.token, params.postId)
            .finally(() => {
                setLoading(false);
            });
        }
    }, [params]);
    
    return (
        <>
            <div className='main-content'>
                <Header page={"profile3"} title={t("User Post Details")} backpage={'/my-profile'} />
                <div className='padding2'>
                    <div className='container'>
                        {loading ? (
                            <div>
                                <p className='py-5 text-center'>Loading...</p>
                            </div>
                            ) : (
                            <>
                                <div className='position-relative'>
                                    <img src={`${process.env.REACT_APP_IMAGES_URL}/${singleUserPost?.image}`} crossOrigin="anonymous" className="img-fluid w-100 rounded-4" alt="" />
                                </div>
                                <div className='d-flex gap-3 justify-content-end mt-3'>
                                    <Link to={`/update-post/${singleUserPost?._id}`}><BiEditAlt className="fs-5" /></Link>
                                    <Link onClick={() => deleteUserPost(singleUserPost?._id)}><FaRegTrashAlt className="fs-5" /></Link>
                                </div>
                                <div className='mt-2'>
                                    <h4 className='fw-bold mb-3'>
                                        {singleUserPost?.title}
                                    </h4>
                                    <h6>
                                        <FaRegCalendarAlt className='me-1' />
                                        <span className='align-middle text-white'>
                                            {new Date(singleUserPost?.date_creation).toLocaleDateString()}
                                        </span>
                                    </h6>

                                    <p className='fw-semibold text-white mb-2 mt-4'>Tags / Categories / Keywords:</p>
                                    <p>{singleUserPost?.tags?.map(tag => tag.name).join(", ")}</p>
                                        
                                    <p className='mb-3 mt-4'>
                                        <span className='fw-semibold text-white'>Media Type:</span> {singleUserPost?.mediatype?.name}
                                    </p>
                                    <p className=''>
                                        <span className='fw-semibold text-white'>Tools / Software Used:</span> {singleUserPost?.software_tools}
                                    </p>

                                    <p className=''>
                                        <span className='fw-semibold text-white'>Collaboration / Credits (if applicable):</span> {singleUserPost?.collaboration_credits}
                                    </p>

                                    {
                                        singleUserPost?.intended_message && <p className=''>
                                            <span className='fw-semibold text-white'>Intended Message / Theme:</span> {singleUserPost?.intended_message}
                                        </p>
                                    }

                                    {
                                        singleUserPost?.project_context && <p className=''>
                                            <span className='fw-semibold text-white'>Project Type or Usage Context</span> {singleUserPost?.project_context}
                                        </p>
                                    }

                                    {
                                        singleUserPost?.skill_level && <p className=''>
                                            <span className='fw-semibold text-white'>Skill Level:</span> {singleUserPost?.skill_level}
                                        </p>
                                    }

                                    <p className=''>
                                        <span className='fw-semibold text-white'>Visibility Settings:</span> {singleUserPost?.visibility_settings}
                                    </p>

                                    <p className=''>
                                        <span className='fw-semibold text-white'>Licensing / Reuse Rights:</span> {singleUserPost?.licensing_reuse_rights}
                                    </p>

                                    <p className='fw-semibold text-white mb-1 mt-4'>Description / Artist Statement:</p>
                                    <p>{singleUserPost?.description}</p>

                                </div>
                            </>
                        )}
                        
                    </div>
                </div>


                <Menu />
            </div>
        </>
    );
};

export default PostDetails;
